import { textSecondary } from 'common/colors';

export default {
  root: {
    color: textSecondary
  }
};
